import script from "./QrReservaAlojamiento.vue?vue&type=script&setup=true&lang=js"
export * from "./QrReservaAlojamiento.vue?vue&type=script&setup=true&lang=js"

import "./QrReservaAlojamiento.vue?vue&type=style&index=0&id=7683ce3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7683ce3b"]])

export default __exports__